function getSafeApiBaseUrl() {
    const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();

    if (typeof window === 'undefined') {
        return configuredBaseUrl;
    }

    const { hostname, protocol } = window.location;
    const isLocalDevHost = hostname === 'localhost' || hostname === '127.0.0.1';

    if (!configuredBaseUrl) {
        return isLocalDevHost ? 'http://localhost:5001' : '';
    }

    try {
        const parsedBaseUrl = new URL(configuredBaseUrl);
        const isConfiguredLocalhost =
            parsedBaseUrl.hostname === 'localhost' || parsedBaseUrl.hostname === '127.0.0.1';

        // Ignore a baked-in localhost API URL once the frontend is deployed remotely.
        if (!isLocalDevHost && isConfiguredLocalhost) {
            return '';
        }
    } catch (_error) {
        // Leave invalid custom values untouched so they remain visible during debugging.
    }

    if (protocol === 'https:' && configuredBaseUrl.startsWith('http://')) {
        return '';
    }

    return configuredBaseUrl;
}

export default getSafeApiBaseUrl;
